var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8CityBuildings1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 22.4001V19.2001H16V22.4001H19.2V19.2001H22.4V16.0001H19.2V12.8001H22.4V9.6001H11.2C10.3168 9.6001 9.60001 10.3169 9.60001 11.2001V22.4001H12.8ZM12.8 12.8001H16V16.0001H12.8V12.8001Z",
    fill: "#FFD708"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 6.3999H27.2C26.3168 6.3999 25.6 7.1167 25.6 7.9999V41.5999H41.6V7.9999C41.6 7.1167 40.8832 6.3999 40 6.3999ZM38.4 12.7999H35.2V9.5999H38.4V12.7999ZM32 12.7999H28.8V9.5999H32V12.7999ZM38.4 19.1999H35.2V15.9999H38.4V19.1999ZM32 19.1999H28.8V15.9999H32V19.1999ZM38.4 25.5999H35.2V22.3999H38.4V25.5999ZM32 25.5999H28.8V22.3999H32V25.5999ZM38.4 31.9999H35.2V28.7999H38.4V31.9999ZM32 31.9999H28.8V28.7999H32V31.9999ZM38.4 38.3999H35.2V35.1999H38.4V38.3999ZM32 38.3999H28.8V35.1999H32V38.3999Z",
    fill: "#22428F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 25.6001H7.99999C7.11679 25.6001 6.39999 26.3169 6.39999 27.2001V41.6001H22.4V27.2001C22.4 26.3169 21.6832 25.6001 20.8 25.6001ZM12.8 38.4001H9.59999V35.2001H12.8V38.4001ZM12.8 32.0001H9.59999V28.8001H12.8V32.0001ZM19.2 38.4001H16V35.2001H19.2V38.4001ZM19.2 32.0001H16V28.8001H19.2V32.0001Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CityBuildings1);
export default __webpack_public_path__ + "static/media/icons8-city-buildings 1.7bcc5b1317290a00e84ee9742b665e4f.svg";
export { ForwardRef as ReactComponent };